/**
 * Generated by orval 🍺
 * Do not edit manually.
 * standard public schema
 * OpenAPI spec version: 16.1
 */
import type {
  DeleteNotificationsParams,
  GetNotificationsParams,
  Notifications,
  NotificationsInsertPayload,
  NotificationsUpdate,
  PatchNotificationsParams,
  PostNotificationsParams,
  PostgrestError
} from '../../models';

import {
  backendBaseUrl
} from '@/api/vtnz-backend/baseUrl';


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export type getNotificationsResponse200 = {
  data: Notifications[]
  status: 200
}

export type getNotificationsResponse206 = {
  data: Notifications[]
  status: 206
}

export type getNotificationsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200 | 206>
}

export type getNotificationsResponseSuccess = (getNotificationsResponse200 | getNotificationsResponse206) & {
  headers: Headers;
};
export type getNotificationsResponseError = (getNotificationsResponseDefault) & {
  headers: Headers;
};

export type getNotificationsResponse = (getNotificationsResponseSuccess | getNotificationsResponseError)

export const getGetNotificationsUrl = (params?: GetNotificationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/notifications?${stringifiedParams}` : `${backendBaseUrl}/notifications`
}

/**
 * @summary Read rows from `notifications`.
 */
export const getNotifications = async (params?: GetNotificationsParams, options?: RequestInit): Promise<getNotificationsResponse> => {

  const res = await fetch(getGetNotificationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getNotificationsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getNotificationsResponse
}


export type postNotificationsResponse201 = {
  data: Notifications[]
  status: 201
}

export type postNotificationsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 201>
}

export type postNotificationsResponseSuccess = (postNotificationsResponse201) & {
  headers: Headers;
};
export type postNotificationsResponseError = (postNotificationsResponseDefault) & {
  headers: Headers;
};

export type postNotificationsResponse = (postNotificationsResponseSuccess | postNotificationsResponseError)

export const getPostNotificationsUrl = (params?: PostNotificationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/notifications?${stringifiedParams}` : `${backendBaseUrl}/notifications`
}

/**
 * @summary Insert one or more rows into `notifications`.
 */
export const postNotifications = async (notificationsInsertPayload: NotificationsInsertPayload,
    params?: PostNotificationsParams, options?: RequestInit): Promise<postNotificationsResponse> => {

  const res = await fetch(getPostNotificationsUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notificationsInsertPayload)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postNotificationsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postNotificationsResponse
}


export type patchNotificationsResponse200 = {
  data: Notifications[]
  status: 200
}

export type patchNotificationsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchNotificationsResponseSuccess = (patchNotificationsResponse200) & {
  headers: Headers;
};
export type patchNotificationsResponseError = (patchNotificationsResponseDefault) & {
  headers: Headers;
};

export type patchNotificationsResponse = (patchNotificationsResponseSuccess | patchNotificationsResponseError)

export const getPatchNotificationsUrl = (params?: PatchNotificationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/notifications?${stringifiedParams}` : `${backendBaseUrl}/notifications`
}

/**
 * @summary Update the rows of `notifications` matching the given filters.
 */
export const patchNotifications = async (notificationsUpdate: NotificationsUpdate,
    params?: PatchNotificationsParams, options?: RequestInit): Promise<patchNotificationsResponse> => {

  const res = await fetch(getPatchNotificationsUrl(params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notificationsUpdate)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: patchNotificationsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as patchNotificationsResponse
}


export type deleteNotificationsResponse200 = {
  data: Notifications[]
  status: 200
}

export type deleteNotificationsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type deleteNotificationsResponseSuccess = (deleteNotificationsResponse200) & {
  headers: Headers;
};
export type deleteNotificationsResponseError = (deleteNotificationsResponseDefault) & {
  headers: Headers;
};

export type deleteNotificationsResponse = (deleteNotificationsResponseSuccess | deleteNotificationsResponseError)

export const getDeleteNotificationsUrl = (params?: DeleteNotificationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/notifications?${stringifiedParams}` : `${backendBaseUrl}/notifications`
}

/**
 * @summary Delete the rows of `notifications` matching the given filters.
 */
export const deleteNotifications = async (params?: DeleteNotificationsParams, options?: RequestInit): Promise<deleteNotificationsResponse> => {

  const res = await fetch(getDeleteNotificationsUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteNotificationsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteNotificationsResponse
}


